import round from 'lodash/round';
import range from 'lodash/range';

import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';

const FiveStars = ({averageRating}) => {
  // round up to the next whole number
  const nextWholeNumber = Math.ceil(averageRating);
  const emptyStars = 5 - nextWholeNumber; // Assuming a 5-star rating system
  const isHalfStar = averageRating % 1 !== 0; // Check if there's a half star
  const color = 'warning'; 
  const fontSize = '1.25rem';
  return (
    <Stack direction='row' spacing={0.5}>
    {
      range(nextWholeNumber).map((num, i) => 
        i < nextWholeNumber - 1
        ? <StarIcon color={color} style={{fontSize}}/>
        : (
          nextWholeNumber - averageRating >= 0.2 
          ? <StarHalfIcon color={color} style={{fontSize}}/> 
          : <StarIcon color={color} style={{fontSize}}/>
        )
      )
    }
    {
      range(emptyStars).map(num => <StarOutlineIcon color={color} style={{fontSize}}/>)
    }
  </Stack>
  );
};
const EmbeddedRating = props => {
  const {provider} = props;
  const reviews = provider?.reviews || [];
  if (!reviews?.length) return null; // No reviews available
  let count = reviews.length;
  let averageRating = reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length;
  averageRating = round(averageRating, 1); // Round to one decimal place
  const averageRatingText = averageRating.toFixed(1); // Format to one decimal place
  const fontWeight = 'medium';
  return (
    <Stack direction='row' alignItems='center' gap={0.5}>
      <StarIcon color='secondary' style={{fontSize: '1.25rem'}} />
      <Typography variant='body1' style={{color: config().colors.secondary, fontWeight}}>
        <span style={{fontWeight}}>{averageRatingText}</span> ({count} review{count > 1 ? 's' : ''})
      </Typography>
    </Stack>
  );
};

export default EmbeddedRating;